export const frequencies = ['daily', 'weekly', 'monthly'] as const;
export const dayOfWeeks = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
] as const;
export const datePatterns = ['1', '5', '10', '15', '20', '25', 'end'] as const;
